<template>
  <div id="login" class="div_card" style="text-align: -webkit-center;">
    <div class="login-shadow" style="margin:1em; max-width: 45em;">
      <div>
        <h3 class="div_account" style="margin:0; text-align:left;">{{title}}</h3>
        <form  id="form-login" method="post">
          <table cellspacing="0" style="width: 100%; border: 0; margin: 0 0 0.4em 0;">
            <tbody>
              <tr>
                <td class="ncut-base-form-title ncut-require-title login-title" style="width:10em;">身分證字號：</td>
                <td class="ncut-base-form-ipt" colspan="2">
                    <el-input v-model="user.text1" placeholder="輸入身分證字號" maxlength="20" tabindex="1" style="width:9.375em;"
                        clearable
                        @change="checkIdNo()">
                      <i class="el-icon-edit el-input__icon"
                        slot="suffix"/></el-input><el-button type="success" plain round icon="el-icon-refresh" style="padding: 0.75em 0.5em; margin: 0 0.5em;" tabindex="2" @click="checkIdNo()">{{$t('message.Check_txt')}}</el-button>
                </td>
              </tr>
              <tr v-show="10 < status">
                <td class="ncut-base-form-title ncut-require-title login-title">密  碼：</td>
                <td class="ncut-base-form-ipt" colspan="2" style="padding: 0 5px 8px 5px;">
                    <el-input type="password" v-model="user.text2" placeholder="輸入密碼" tabindex="3" style="width:9.375em;"
                        @change="chkPWStrong();getDeptLst();">
                      <i class="el-icon-edit el-input__icon"
                        slot="suffix"/></el-input>
                </td>
              </tr>
              <tr v-show="12 == status">
                <td class="ncut-base-form-title ncut-require-title login-title">報考系別：</td>
                <td class="ncut-base-form-ipt" colspan="2">                
                    <el-select v-model="user.dId" placeholder="選擇報考系別"
                        tabindex="4"
                        style="width: 20em;">
                        <el-option
                          v-for="item in deptList"
                          :key="item.dptcdID"
                          :label="item.dptcdName"
                          :value="item.dptcdID">
                        </el-option>
                        <el-option key="0" label="請選擇" :value="0" :disabled="true"></el-option>
                    </el-select>
                </td>
              </tr>
              <tr v-show="10 < status">
                <td class="ncut-base-form-title ncut-require-title login-title">驗 證 碼：</td>
                <td class="ncut-base-form-ipt" colspan="2">
                    <el-input class="input-205"  v-model="user.text3" placeholder="輸入驗證碼" maxlength="6" tabindex="5" style="width:9.375em;">
                      <i class="el-icon-edit el-input__icon"
                        slot="suffix"/></el-input><br/><br/>               
                    <img v-if="captchaInfo != null" :src="captchaInfo" style="margin: 0 0 0 0; height: 2.25em;" alt=""><a href="#" style="padding: 5px 0.6em;" title="重新產生驗證碼" tabindex="6"  @click.prevent="getCaptcha()">
                    <i class="el-icon-refresh"></i>
                    </a> 
                </td>
              </tr>                                    
              <tr v-show="2 == status">
                <td class="ncut-base-form-title ncut-require-title login-title">設定密碼：</td>
                <td class="ncut-base-form-ipt" colspan="2">
                    <el-input class="input-205" type="password" v-model="newPsd1" placeholder="輸入新密碼" maxlength="16" tabindex="7" style="width:9.375em;"
                        @change="chkPWStrong()"></el-input>
                </td>
              </tr>
              <tr v-show="2 == status">
                <td class="ncut-edit-form-text login-title">密碼強度偵測</td>
                <td class="ncut-base-form-ipt" colspan="2">
                    <span v-show="pwStrength==0" style="border-color: #eeeeee;">密碼強度偵測</span>
                    <span v-show="pwStrength==1" style="border-color: #FF0000;color:#986524;font-weight: bolder;">弱</span>
                    <span v-show="pwStrength==2" style="border-color: #FF9900;color:#986524;font-weight: bolder;">中</span>
                    <span v-show="pwStrength>2" style="border-color: #33CC00;color:#986524;font-weight: bolder;">強</span>
                </td>
              </tr>
              <tr v-show="2 == status">
                <td class="ncut-base-form-title ncut-require-title login-title">確認密碼：</td>
                <td class="ncut-base-form-ipt" colspan="2">
                    <el-input class="input-205" type="password" v-model="newPsd2" placeholder="輸入確認密碼" maxlength="16" tabindex="8" style="width:9.375em;" ></el-input>
                </td>
              </tr>
              <tr v-show="2 == status">
                <td class="ncut-base-form-text"></td>
                <td class="ncut-base-form-ipt" colspan="2" style="color:red;">
                    *密碼強度需求等級：中<br />
                    *密碼最少須有8字元以上
                </td>
              </tr>
              <tr v-show="3 == status"> 
                <td class="ncut-base-form-ipt" colspan="3" style="padding: 0.2em 1em 0.2em 4em;">
                    <br />
                    * 查無此身分證字號，如果疑問請洽招生事務處。
                </td>
              </tr>
              <tr v-show="2 == status">
                <td style="height:3em; padding: 2em 10em 0; text-align: center!important;" colspan="3">
                    <el-button type="primary" tabindex="9" @click.prevent="savePW()" >
                    <span class="glyphicon glyphicon-log-in" style="margin-right: 4px;"></span> {{$t('message.Confirm_txt')}}
                    </el-button>
                </td>
              </tr>
              <tr v-show="10 < status">
                <td style="padding: 2em 10em 0;" colspan="3">
                    <el-button type="primary" tabindex="10" @click.prevent="login()">
                    <span class="glyphicon glyphicon-log-in" style="margin-right: 4px;"></span> {{$t('message.Sign_in')}}
                    </el-button>
                </td>
              </tr>
              <tr v-show="10 < status">
                <td class="ncut-base-form-text"></td>
                <td class="ncut-base-form-ipt" colspan="2">
                  <span style="color:red;">請注意：輸入錯誤達5次(含)，將鎖定帳號15分鐘!</span><br/>
                  <span style="color:black;">登入密碼為民國出生年月日共6碼</span>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                    &nbsp;
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
    <br/>
  </div>
</template>

<script>

export default {
  name: 'login',
  data () {
    return {
      groupID: 0,
      deptList: null,
      user: {
        eId: 0,
        gId: -1,
        dId: 0,
        stdId: -1,
        text1: '',
        text2: '',
        text3: '',
        isLogin: true        
      },
      title: '',
      status: -1,
      captchaInfo: null,
      newPsd1: '',
      newPsd2: '',
      pwStrength: ''
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
  },
  methods: {
    chkPWStrong: function() {
        this.pwStrength = this.checkStrong(this.newPsd1);
    },
    setStatus: function (flag) {
        this.status = flag;
        switch (flag) {
            case 2:
                this.title = '第一次登入設定密碼';
                break;
            case 11:
            case 12:
                this.getCaptcha();
            default:
                this.title = '考生登入';
                this.getCaptcha();
                break;
        } 
    },
    checkPSWData: function () {
        var msg = '';
                
        if (this.newPsd1 != this.newPsd2) {
            msg = '所輸入的密碼不一樣，請重新輸入';
        } else if (this.checkStrong(this.newPsd1) < 2) {
            msg = '密碼強度不足';
        } else {
            this.user.text2 = this.newPsd1;
        } 

        return msg;
    },
    savePW: function () {
        var msg = this.checkPSWData();
        if (msg.length == 0) {
            var vm = this;
            this.$http.put('./WebApi/Apply/SetUserPassrod', this.user)
                .then((response) => {
                    if (null != response.data) {
                      //  vm.$message({
                      //       message: '恭喜您,存檔成功',
                      //       type: 'success'
                      //     });   
                        vm.$notify({
                                      title: vm.$t('message.Success_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>恭喜您,存檔成功</strong>',
                                      type: 'success',
                                      offset: 150
                                  });
                        vm.setStatus(response.data.status);
                        vm.checkIdNo();
                    }
                })
                .catch(function (error) {
                  //vm.$message.error('對不起,網路連線失敗' + error)
                  vm.$notify.error({
                                      title: vm.$t('message.Error_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>對不起,網路連線失敗</strong>',
                                      offset: 150
                                  });
                })
        } else {
          //this.$message.error('對不起,請輸入' + msg);
          this.$notify.error({
                                title: this.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,請輸入<i style="background:yellow;">'+msg+'</i></strong>',
                                offset: 150
                            });
        }
    },
    checkSaveData: function () {
        var msg = '';

        if ((null == this.user.text1) || (this.user.text1.length == 0)) {
            msg = '身分證字號';
        } else if (this.user.text1.length < 10) {
            msg = '正確的身分證字號 (長度大於、等於10)';
        } else if (this.user.text2.length == 0) {
            msg = '請輸入密碼';
        }

        return msg;
    },
    setGroupID: function (){
      if ((null != this.deptList) && (this.user.dId > 0)) {          
        var dLen = this.deptList.length;
        for (var i = 0; i < dLen; i++) {
          if (this.deptList[i].dptcdID == this.user.dId) {
            this.user.gId = this.deptList[i].groupID;
            break;
          }
        }
      }
    },
    login: function () {
        var msg = this.checkSaveData();
        if (msg.length == 0) {
          var vm = this
          this.setGroupID();          
          this.$http.put('./WebApi/Common/Authorized', this.user)
              .then((response) => {
                  var tmpData = response.data
                  if (tmpData != null && tmpData.locked) {
                    vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>警告!!本帳號已被鎖定，請稍後再使用。</strong>',
                                        offset: 150
                                    });
                    vm.user.text1 = '';
                    vm.user.text2 = '';  
                    return;
                  }
                  if ((tmpData != null) && (tmpData.usrData.id === vm.user.text1)) {
                    console.log('set Authorized' + tmpData.usrData.id)
                    // vm.$message({
                    //     message: tmpData.usrData.name +'登入成功',
                    //     type: 'success'
                    //   });
                    vm.$notify({
                                  title: vm.$t('message.Success_txt'),
                                  dangerouslyUseHTMLString: true,
                                  message: '<strong><i style="background:yellow;">'+tmpData.usrData.name+'</i>登入成功</strong>',
                                  type: 'success',
                                  offset: 150
                              });
                    vm.$store.dispatch('actionLogin', tmpData.usrData);    
                    this.$emit('getDefaultMenu', this.sysId, false);
                  } else {
                    //vm.$message.error('請檢查帳號密碼是否輸入正確')
                    vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>請檢查<i style="background:yellow;">帳號密碼</i>是否輸入正確</strong>',
                                        offset: 150
                                    });
                    vm.user.text2 = ''
                  }
              })
              .catch(function (error) {
                //vm.$message.error('請檢查帳號密碼是否輸入正確')
                vm.$notify.error({
                                    title: vm.$t('message.Error_txt'),
                                    dangerouslyUseHTMLString: true,
                                    message: '<strong>請檢查<i style="background:yellow;">帳號密碼</i>是否輸入正確</strong>',
                                    offset: 150
                                });
              })
        } else {
          //this.$message.error('對不起,請輸入' + msg);
          this.$notify.error({
                                title: this.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,請輸入'+msg+'</strong>',
                                offset: 150
                            });
        }
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Tools/GetCaptcha/')
        .then(function (response) {
          vm.captchaInfo = response.data
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗' + error)
          vm.$notify.error({
                              title: vm.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                              offset: 150
                          });
        })
    },
    getGroupSet: function () {
      return this.$http
                 .get('./WebApi/Apply/GetGroupSet/'.concat(this.sysId).concat('/3'));
    },
    getDeptLst: function () {
      var vm = this
      let url = './WebApi/Apply/GetSelDeptByID/'.concat(this.user.eId).concat('/').concat(this.user.stdId);
      this.$http
        .get(url)
        .then(function(response) {
          vm.deptList = response.data;
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗');
          vm.$notify.error({
                              title: vm.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                              offset: 150
                          });
        })            
    },
    checkIdNo: function () {
        if ((null != this.user.text1) && (10 <= this.user.text1.length)) {
            var vm = this
            this.user.text1 = this.user.text1.toUpperCase();      
            this.$http
                .put("./WebApi/Apply/CheckIdNo",this.user)
                .then(function(response) {
                    if ((response.data != null) && (response.data != undefined) && (response.data != "null") ) {
                        vm.setStatus(response.data.status);
                        if (10 < response.data.status) {
                            vm.user.gId = response.data.groupID;
                            vm.user.dId = response.data.deptID;
                            vm.user.stdId = response.data.stdId;
                            if (12 == vm.status) {
                                vm.getDeptLst();
                            }
                        }
                    }
                })
                .catch(function (error) {
                    //vm.$message.error('對不起,網路連線失敗');
                    vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                        offset: 150
                                    });
                })
        }
    },
    checkStrong: function (sPW) {
        var modes = 0;

        if (sPW.length <= 7) {
            return 1; //密碼太短
        }

        for (var i = 0; i < sPW.length; i++) {
            //測試每一個字符的類別並統計一共有多少種模式.
            modes |= this.charMode(sPW.charCodeAt(i));
        }

        return this.bitTotal(modes);
    },
    bitTotal: function (num) {
        var modes = 0;

        for (var i = 0; i < 4; i++) {
            if (num & 1) {
                modes++;
            }
            num >>>= 1;
        }

        return modes;
    },
    charMode: function(iN) {
        var ret = 0;

        if ((iN >= 48) && (iN <= 57)) { //數字
            ret = 1;
        }
        else if ((iN >= 65) && (iN <= 90)) { //大寫字母
            ret = 2;
        }
        else if ((iN >= 97) && (iN <= 122)) { //小寫
            ret = 4;
        }
        else { //特殊字符
            ret = 8;
        }

        return ret;
    }
  },
  created () {
    console.log('======created Login =====');
    this.user.eId = this.setting.enrollID[0].codeName;
    this.setStatus(-1);
    // this.getCaptcha()
    var vm = this
    this.$http.all([vm.getGroupSet()])
        .then(vm.$http.spread(function (groupInfo) {
          if ((0 == vm.groupID) && (1 == groupInfo.data.length)) {
            vm.groupID = groupInfo.data[0].groupID;
            vm.user.gId = groupInfo.data[0].groupID;
          }
        }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-205 {
  height: 2.05em;
  padding: 0.2em;
}
.ncuthead_01 {
  position: relative;
  height: 102px;
  background: transparent;
  background-position: 0px 0px;
  display: contents;
}
.ncuttitle {
  left: 9.5em;
  padding-bottom: 0px;
  position: absolute;
  top: 1.15em;
  font-size: 2.25em;
  font-weight: bolder;
  color: #161823;
  font-family: -apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}
.loginMenu {
  border-left: none;
  padding-left: 0;
  margin: 0;
  padding-right: .75em;
  line-height: 0.6;
  display: inline-block;
  list-style-type: none;
  list-style-position: inside;
  padding: .5em 0;
}
.itemMenu {
  border-left: 1px solid rgba(0,0,0,0.1);
  padding-left: .75em;
  padding-right: .75em;
  line-height: 0.6;
}
.form_login {
  width: 26.875em;
  height: 15.5em;
  margin: 150px auto;
  text-align: center;
  padding-top: 20px;
  border: 1px solid gray;
  vertical-align: top;
  border-radius: 4px;
  font-size: larger;
  background: linear-gradient(135deg,rgba(255,255,255,1) 0%,rgba(246,246,246,1) 60%,rgba(237,237,237,1) 100%);
}
.login-shadow {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 5px 7px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2),0 5px 7px 0 rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 5px 7px 0 rgba(0, 0, 0, 0.19);
}
.login-title {
  vertical-align: middle;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginView.vue